<template>
  <!--设备远程控制组件-->
  <div class="el-tabs__content">
    <h1>远程控制</h1>
    <el-table :data="telecontrolData">
      <el-table-column prop="packetName" label="功能名称"></el-table-column>
      <el-table-column prop="packetCode" label="功能编码">
      </el-table-column>
      <el-table-column prop="lastExecuteTime" label="上一次执行时间">
        <template slot-scope="scope">
          <span>{{ changeDate(scope.row.lastExecuteTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button class="tableButton" type="text" @click="executeBtn(scope.row)">
            执行
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 远程控制执行 -->
    <el-dialog :append-to-body="true" class="floorDialog" :show-close="false" title="执行下发控制"
      :visible.sync="executeDialog" width="400px" :close-on-click-modal="false">
      <h3 class="explain">
        说明：<br />
        请在“实时数据”页面查看对应属性 当前值，再确定修改。
      </h3>
      <el-form :model="executeForm" ref="executeForm">
        <el-form-item v-for="(item, index) in executeForm.params" :key="index" :label="item.name"
          style="background-color:transparent;padding: 0 20px;" :prop="'params.' + index + '.value'"><br>
          <div style="color: #9B9B9B;font-size: 12px;line-height: 14px;">{{item.fieldDesc}}</div>
          <el-input v-model="item.value" placeholder="请输入参数值" autocomplete="off" style="margin-top:5px;width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item v-if="executeForm.params.length == 0" label="执行"
          style="background-color:transparent;padding: 0 20px;">
          <br />
          <span style="font-weight: bold;font-size:17px;">{{
            executeObj.packetName
          }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="executeDialog = false">取 消</el-button>
        <el-button type="primary" @click="executeConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    name: "remote-control",
    data() {
      return {
        telecontrolData: [], //远程控制指令列表
        executeDialog: false, //执行弹框
        executeForm: {
          params: [] //执行数组
        }, //执行弹框数据
        executeObj: {},
      };
    },
    props: {
      deviceId: '', //父组件传过来的设备id参数
      deviceCode: '', //父组件传过来的设备code参数
    },
    watch: {
      deviceId: {
        handler(newVal, oldVal) {
          this.getDeviceTelecontrol();
        },
        deep: true
      },
    },
    methods: {
      //初始化时间
      changeDate(time) {
        if (!time) return '';
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //执行按钮
      executeBtn(row) {
        //把数据放到executeObj里
        this.executeObj = row;
        this.executeForm.packetCode = row.packetCode;
        this.executeDialog = true;
        API.platformDevDevicePackFeilds({
          id: row.id
        }).then(res => {
          if (res.code == 1) {
            this.executeForm.params = res.data;
          }
        });
      },
      //执行保存
      executeConfirm() {
        //当不需要填写任何东西时this.executeForm.params就为空
        if (this.executeForm.params.length == 0) {
          let para = {
            deviceCode: this.deviceCode,
            packetCode: this.executeForm.packetCode
          };
          API.tcpctrlfun(para).then(res => {
            if (res.code == 1) {
              this.$message.success("执行成功");
              // this.executeDialog = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          //需要自行填写数据时做校验
          this.$refs.executeForm.validate(valid => {
            if (valid) {
              let params = {};
              this.executeForm.params.forEach(function (item) {
                params[item['code']] = item.value;
              })
              let para = {
                deviceCode: this.deviceCode,
                packetCode: this.executeForm.packetCode,
                params: params
              };
              API.tcpctrlfun(para).then(res => {
                if (res.code == 1) {
                  this.$message.success("执行成功");
                  // this.executeDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.$message({
                message: "请填写完所有必填项",
                type: "error"
              });
              return false;
            }
          });
        }
      },
      //根据设备查找远程控制指令列表
      getDeviceTelecontrol() {
        API.platformDevDeviceTelecontrol(this.deviceId).then(res => {
          if (res.code == 1) {
            this.telecontrolData = res.data;
          }
        })
      }
    },
    mounted() {
      this.getDeviceTelecontrol();
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/device/remoteControl.vue